/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import IPAddress from './IPAddress';
import X509Certificate2 from './X509Certificate2';

/**
 * The ConnectionInfo model module.
 * @module model/ConnectionInfo
 * @version V1
 */
class ConnectionInfo {
    /**
     * Constructs a new <code>ConnectionInfo</code>.
     * @alias module:model/ConnectionInfo
     */
    constructor() { 
        
        ConnectionInfo.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ConnectionInfo</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ConnectionInfo} obj Optional instance to populate.
     * @return {module:model/ConnectionInfo} The populated <code>ConnectionInfo</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ConnectionInfo();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('remoteIpAddress')) {
                obj['remoteIpAddress'] = IPAddress.constructFromObject(data['remoteIpAddress']);
            }
            if (data.hasOwnProperty('remotePort')) {
                obj['remotePort'] = ApiClient.convertToType(data['remotePort'], 'Number');
            }
            if (data.hasOwnProperty('localIpAddress')) {
                obj['localIpAddress'] = IPAddress.constructFromObject(data['localIpAddress']);
            }
            if (data.hasOwnProperty('localPort')) {
                obj['localPort'] = ApiClient.convertToType(data['localPort'], 'Number');
            }
            if (data.hasOwnProperty('clientCertificate')) {
                obj['clientCertificate'] = X509Certificate2.constructFromObject(data['clientCertificate']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ConnectionInfo</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ConnectionInfo</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
            throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
        }
        // validate the optional field `remoteIpAddress`
        if (data['remoteIpAddress']) { // data not null
          IPAddress.validateJSON(data['remoteIpAddress']);
        }
        // validate the optional field `localIpAddress`
        if (data['localIpAddress']) { // data not null
          IPAddress.validateJSON(data['localIpAddress']);
        }
        // validate the optional field `clientCertificate`
        if (data['clientCertificate']) { // data not null
          X509Certificate2.validateJSON(data['clientCertificate']);
        }

        return true;
    }


}



/**
 * @member {String} id
 */
ConnectionInfo.prototype['id'] = undefined;

/**
 * @member {module:model/IPAddress} remoteIpAddress
 */
ConnectionInfo.prototype['remoteIpAddress'] = undefined;

/**
 * @member {Number} remotePort
 */
ConnectionInfo.prototype['remotePort'] = undefined;

/**
 * @member {module:model/IPAddress} localIpAddress
 */
ConnectionInfo.prototype['localIpAddress'] = undefined;

/**
 * @member {Number} localPort
 */
ConnectionInfo.prototype['localPort'] = undefined;

/**
 * @member {module:model/X509Certificate2} clientCertificate
 */
ConnectionInfo.prototype['clientCertificate'] = undefined;






export default ConnectionInfo;

